import axios, {AxiosResponse} from 'axios';
import {AuthenticationResponse, UserAuthResponse} from '@/model/CommonModel';
import AppSession from '@/store/AppSession';

export default class UserAuthenticationApi {
    public static authentication(userId: string, password: string, additional: any = {}): Promise<AuthenticationResponse> {
        return axios
            .post(`/1.0/auth`, {userId, password, ...additional})
            .then((res: AxiosResponse) => res.data);
    }
    
    public static getUserAuth(sponsorKey: string | number | undefined): Promise<UserAuthResponse> {
        if (sponsorKey === undefined) {
            return new Promise(resolve => resolve());
        }
    
        return axios
            .get(`/1.0/auth/${sponsorKey}`)
            .then((res: AxiosResponse) => res.data);
    }
    
    public static logout(sponsorKey: string, reason: string): Promise<any> {
        return axios
            .post(`/1.0/sponsors/${sponsorKey}/users/${AppSession.getUserKey()}/logout`, {reason})
            .then((res: AxiosResponse) => res.data);
    }
}
